<div class="wrong-organization">
  @if (hasAccess()) {
    <h3>{{ 'wrongOrganization.title' | translate }}</h3>
    <p>
      {{ 'wrongOrganization.message' | translate: { orgName: targetOrgName() ?? targetOrgId() } }}
    </p>
    <evc-button
      type="primary"
      frame="full"
      [text]="'wrongOrganization.switchButton' | translate: { orgName: targetOrgName() ?? targetOrgId() }"
      (click)="onSwitchOrganization()"
    ></evc-button>
  } @else {
    <h3>{{ 'wrongOrganization.noAccessTitle' | translate }}</h3>
    <p>{{ 'wrongOrganization.noAccessMessage' | translate }}</p>
    <evc-button type="primary" frame="full" [text]="'wrongOrganization.goHomeButton' | translate" (click)="onGoHome()"></evc-button>
  }
</div>
